module.exports = __webpack_public_path__ + "img/blog6-logo-6.6d2bc37b.webp";